import type { FaireProductEntity } from "../../entity_types/product";

export const p_6apftqxccs: FaireProductEntity = {
  token: "p_6apftqxccs",
  type: "product",
  name: "French Lavender Hand Cream 1 oz – Flower Market",
  brandToken: "b_hcbhgx8v9w",
  brandName: "123 Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/989ddbed9b6865ccbcdbe1ab7531582df043a61f112d5b7eaf4bd954550c688a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9d2b212fd435b4abee873cd89bba3fdbf0a93d843c018fdcecddb64ea67790b0.jpeg",
  ],
  priceDollars: 2.74,
  description:
    "Pamper your hands with our French Lavender Hand Cream, a luxurious 1 oz blend infused with the calming essence of lavender. Perfect for soothing and hydrating dry hands, this cream leaves your skin feeling soft, smooth, and delicately scented. Lightweight and non-greasy, it absorbs quickly while providing lasting hydration.\n\nCrafted with nourishing ingredients:\nShea Butter: Deeply moisturizes and protects.\nJojoba and Olive Oils: Hydrate and soften.\nAloe Vera and Centella Extracts: Soothe and rejuvenate.\nVitamin E and Panthenol: Improve texture and protect against dryness.\nTesters are available for this product.\n\nIngredients List:\nAqua (Water), Butyrospermum Parkii (Shea) Butter, Lavandula Hybrida Oil, Cetearyl Alcohol, Glycerin, Ceteareth-25, Isopropyl Myristate, Ethylhexyl Palmitate, Glyceryl Stearate, Stearic Acid, Phenoxyethanol, Acrylates/C10-30 Alkyl Acrylate Crosspolymer, Chlorphenesin, Acrylates/Stearyl Methacrylate Copolymer",
  tags: [],
  msrpDollars: 5.48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:37.440Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
